
/**
 * 导出当前仓库 npm 版本
 */

// TODO: this is special because it gets imported during pub.
const version = '0.0.359-hotfix9';

export default version;
